export default __webpack_public_path__ + "static/media/con_MOVG09.f3a3197e.jpg";